export default __webpack_public_path__ + "static/media/basemap3.7c355996.jpg";